import findParent from './findParent';

/**
 * Finds the first ancestor that has an overflow of auto or scroll.
 */
const findScrollContainer = findParent((el) => {
  const { overflow } = window.getComputedStyle(el);
  return overflow.includes('auto') || overflow.includes('scroll');
});

export default findScrollContainer;
